<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <div class="spinner" *ngIf="isLoading; else protectAndSavePage"></div>
  <ng-template #protectAndSavePage>
    <section>
      <div class="content-wrapper pos-rel-md">
        <app-page-retrieval-error
          *ngIf="pageRetrievalError"
        ></app-page-retrieval-error>
        <h1 class="title">{{ pageData.title }}</h1>
        <div class="separator"></div>
        <p class="intro">{{ pageData.intro }}</p>
      </div>
    </section>
    <div class="pas-banner-wrapper">
      <app-banner
        *ngIf="pageData"
        [pageData]="pageData"
        [cardStyle]="'tertiary'"
      ></app-banner>
    </div>
    <section class="bottom-section">
      <div class="content-wrapper generic-tab-container">
        <app-generic-tabs
          *ngIf="tabData"
          [tabData]="tabData"
          (selectedTab)="onTabChanged($event)"
        ></app-generic-tabs>
      </div>

      <div class="content-wrapper pas-products-wrapper">
        <div class="pas-product" *ngFor="let product of currentProductData">
          <div
            *ngIf="product.image?.data?.attributes?.url"
            class="pas-logo-wrapper"
          >
            <img
              class="pas-product-image"
              [src]="product.image?.data?.attributes?.url"
            />
          </div>
          <div>
            <h2>{{ product.title }}</h2>
            <div class="pas-product-content">
              <p>{{ product.intro }}</p>
              <div class="pas-product-buttons">
                <a
                  [href]="
                    product.get_quote_cta
                      ? userService.addUserIDToURL(product.get_quote_cta)
                      : ''
                  "
                  [target]="product.get_quote_cta"
                  ><button class="button">
                    {{ product.get_quote_cta_text }}
                  </button></a
                >
                <a
                  *ngIf="product.more_info?.data?.attributes?.uid"
                  [routerLink]="
                    '/app/protect-and-save/' +
                    product.more_info.data.attributes.uid
                  "
                  ><button class="button dashboard-btn">
                    {{ product.more_info_text }}
                  </button></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-template>
</div>
